import { parseResponseError } from "../Utils/errorUtils";
import axiosInstance from "../Utils/axiosInstance";
/**
 * Generic function for put api call
 * @param {*} path is the full path
 * @param {*} data
 * @returns
 */
export const putCall = async (path, data) => {
  try {
    let response = await axiosInstance.put(`${path}`, data);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
  }
};
